{
  "DE": {
    "appTitle": "TNG Weihnachtskarten-Adresssammlung",
    "appTitleTest": "--- TEST --- TNG Weihnachtskarten-Adresssammlung",
    "pleaseLogIn": "Bitte zuerst anmelden",
    "unknownErrorTryAgainLater": "Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.",
    "projectCardListTitle": "Weihnachtskarten-Unterschriftsliste",
    "projectCardListShepherds": "Shepherds",
    "projectCardListEmptyList": "In diesem Projekt gibt es noch keine Karten.",
    "projectCardListNoMatchingCards": "Keine Karte in diesem Projekt passt zur Suche.",
    "globalSearchListTitle": "Globale Kartensuche",
    "exportCards": "Karten exportieren",
    "errorExportCards": "Fehler beim Exportieren der Karten",
    "exportEmails": "E-Mails exportieren",
    "errorExportEmails": "Fehler beim Exportieren der E-Mails",
    "globalSearchMoreCardsWarning": "Mehr als 100 Karten gefunden. Bitte Suche weiter einschränken.",
    "globalSearchNoResults": "Keine Karten gefunden.",
    "cardTableHeaderName": "Name",
    "cardTableHeaderSigned": "Unterschrieben",
    "cardTableHeaderDepartmentName": "Abteilung",
    "cardTableHeaderEmail": "E-Mail",
    "cardTableHeaderProject": "Projekt",
    "cardTableHeaderDispatch": "Versand",
    "cardTableHeaderSender": "Versender",
    "cardTableHeaderCompanyName": "Firma",
    "cardTableHeaderReceivesGift": "Geschenk",
    "cardTableHeaderLanguage": "Sprache",
    "cardTableHeaderComment": "Kommentar",
    "cardTableHeaderCreatedAt": "Erstellt (UTC)",
    "cardTableHeaderLastChangedAt": "Letzte Änderung (UTC)",
    "cardTableHeaderSalutation": "Anrede",
    "cardTableHeaderFormality": "Formalität",
    "cardTableHeaderTitle": "Titel",
    "cardTableCellDispatchAutomatic": "auto",
    "cardTableCellDispatchManual": "manuell",
    "cardTableCellYes": "ja",
    "cardTableCellNo": "nein",
    "searchCardsPlaceholder": "Karten durchsuchen...",
    "noPermissionToViewProject": "Du hast keinen Zugriff auf diese Liste.",
    "noPermissionToViewProjectContact": "Du hast keinen Zugriff auf diese Liste. Um Zugriff zu erhalten, wende dich bitte an einen der Shepherds (siehe oben).",
    "signCard": "Karte unterschreiben",
    "signatureOnlyRemovable": "Du hast keinen Zugriff mehr auf dieses Projekt. Du kannst nur deine Unterschrift entfernen.",
    "errorCardDelete": "Fehler beim Löschen der Karte",
    "errorRemovingSharedCard": "Fehler beim Entfernen der geteilten Karte",
    "licenses": "Lizenzen",
    "formal": "formell",
    "informal": "informell",
    "semiFormal": "semi-formell",
    "departmentName": "Abteilung",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "email": "E-Mail",
    "formalityLabel": "Formalität",
    "receivesGift": "Erhält Geschenk",
    "automaticDispatch": "Automatischer Versand durch die IIT",
    "languageLabel": "Sprache der Karte",
    "english": "Englisch",
    "german": "Deutsch",
    "male": "männlich",
    "female": "weiblich",
    "cancel": "Abbrechen",
    "saveChanges": "Speichern",
    "saveAndNew": "Speichern & Neu",
    "shareCard": "Teilen",
    "changesSaved": "Änderungen gespeichert.",
    "errorSavingChanges": "Fehler beim Speichern der Änderungen",
    "editCardTitle": "Karte bearbeiten",
    "classificationReasonTypoEmailOrName": "E-Mail-Adresse und Name passen möglicherweise nicht zusammen oder enthalten möglicherweise einen Tippfehler.",
    "classificationReasonMismatchSalutation": "Die Anrede passt möglicherweise nicht zum Vornamen.",
    "markContactDetailsCorrect": "Als korrekt markieren",
    "markContactDetailsCorrectDialogTitle": "Kontaktdaten als korrekt markieren",
    "markContactDetailsCorrectDialogMessage": "Korrekte Daten sind wichtig, um TNG extern professionell darzustellen.\nMöchtest du diese Kontaktdaten wirklich als korrekt markieren?",
    "contactDetailsMarkedCorrect": "Die Kontaktdaten wurden als korrekt markiert.",
    "errorMarkingContactDetailsCorrect": "Fehler beim Markieren der Kontaktdaten als korrekt",
    "editCardSignatures": "Unterschriften bearbeiten",
    "addCardSignatures": "Unterschriften hinzufügen",
    "removeCardSignatures": "Unterschriften entfernen",
    "cardSignaturesToAdd": "Hinzuzufügende Unterschriften",
    "cardSignaturesToRemove": "Zu entfernende Unterschriften",
    "firstNameRequired": "Vorname ist erforderlich.",
    "lastNameRequired": "Nachname ist erforderlich.",
    "emailRequiredForAutomaticDispatch": "E-Mail ist erforderlich, wenn automatischer Versand aktiv ist.",
    "senderRequiredForManualDispatch": "Versender ist erforderlich, wenn automatischer Versand deaktiviert ist.",
    "emailSenderNotPossibleForManualDispatch": "Manueller Versand ist mit einem E-Mail-Versender nicht möglich.",
    "selectAtLeastOneShepherd": "Mindestens ein Shepherd muss ernannt werden.",
    "noSemiFormalAvailable": "Eine semi-formelle Anrede ist für die gewählte Sprache nicht verfügbar.",
    "inputRequired": "Eingabe ist erforderlich.",
    "salutation": "Anrede",
    "title": "Titel",
    "none": "Kein",
    "sender": "Versender",
    "comment": "Kommentar",
    "companyName": "Firma",
    "salutationHelperText": "Wenn du für einen Kontakt eine neutrale/diverse Anrede wünschst, schreibe bitte eine E-Mail an communications@tngtech.com.",
    "formalityHelperTextDE": "- formell → \"Sehr geehrte Frau $Nachname / Sehr geehrter Herr $Nachname\"\n- semi-formell → \"Liebe Frau $Nachname / Lieber Herr $Nachname\"\n- informell → \"Liebe/r $Vorname\"",
    "formalityHelperTextEN": "- formell → \"Dear Mr $Last Name / Dear Ms $Last Name\"\n- informell → \"Dear $First Name\"",
    "emailHelperText": "Wenn keine Empfänger-E-Mail angegeben wird, musst du die Karte manuell versenden.",
    "commentHelperText": "Hier können sämtliche Anmerkungen gemacht werden, die euch helfen. Wir sichten und beachten diese jedoch nicht.",
    "receivesGiftHelperText": "Der Kontakt erhält einen Schokoladengutschein. Bitte nicht auswählen, wenn der Kontakt außerhalb Deutschlands wohnt (hohe Versandkosten).",
    "automaticDispatchHelperText": "Wenn deaktiviert, wird die Karte dem Versender für den manuellen Versand zur Verfügung gestellt. Bitte stelle sicher, dass die Karte den Weg zur Empfängerin bzw. zum Empfänger findet!",
    "senderHelperText": "Über dieses Postfach wird die Karte versendet. Auswählbar sind Einzelpersonen und die vordefinierten Postfächer im Dropdown, aber keine Mailinglisten.",
    "createCardTitle": "Karte erstellen",
    "errorCardEmailNotUnique": "Eine Karte mit dieser E-Mail-Adresse existiert bereits.",
    "shareCardWarning": "Diese Karte existiert bereits in einem anderen Projekt",
    "shareCardOption": "Wenn du sie auch mit diesem Projekt verknüpfen möchtest, kannst du sie hier teilen.",
    "errorCardNameNotUnique": "Eine Karte mit diesem Namen existiert bereits.",
    "createCardButton": "Karte erstellen",
    "manageProjectButton": "Projekt verwalten",
    "manageProjectPermissions": "Projektberechtigungen verwalten",
    "errorProjectNameNotUnique": "Ein Projekt mit diesem Namen existiert bereits.",
    "displayNameRequired": "Display Name ist erforderlich.",
    "displayName": "Display Name",
    "infoBox": "Zusätzliche Informationen",
    "infoBoxHelperText": "Zusätzliche Informationen zum Projekt",
    "projectShepherds": "Project Shepherds",
    "projectMembers": "Project Members",
    "projectSigners": "Project Signers",
    "projectShepherdIndividuals": "Shepherd-Personen",
    "projectMemberIndividuals": "Member-Personen",
    "projectSignerIndividuals": "Signer-Personen",
    "projectShepherdGroups": "Shepherd-Gruppen",
    "projectMemberGroups": "Member-Gruppen",
    "projectSignerGroups": "Signer-Gruppen",
    "displayNameHelperText": "Bitte verwende einen eindeutigen Namen für dein Projekt.",
    "projectShepherdsHelperText": "Können Projekteinstellungen und Berechtigungen verwalten.",
    "projectMembersHelperText": "Können Karten anlegen, bearbeiten und löschen.",
    "projectSignersHelperText": "Können Karten unterschreiben, aber keine vertraulichen Kontaktdaten sehen oder bearbeiten.",
    "groupSelectionHelperText": "Zur Auswahl stehen alle deine eigenen LDAP-Gruppen. Du kannst aber jede beliebige LDAP-Gruppe hinzufügen, indem du sie ins Feld eintippst oder hineinkopierst.",
    "projects": "Projekte",
    "loading": "...wird geladen...",
    "noOptions": "<leer>",
    "delete": "Löschen",
    "cardDeleted": "Karte gelöscht.",
    "sharedCardRemoved": "Geteilte Karte entfernt.",
    "createProject": "Projekt erstellen",
    "deleteConfirmationTitle": "Karte löschen",
    "deleteConfirmationMessage": "Bist du sicher, dass die Karte gelöscht werden soll?\nEmpfänger: {recipient}",
    "deleteConfirmationMessageWithSharedCards": "Diese Karte ist momentan mit einem oder mehreren anderen Projekten geteilt. Wenn du sie hier löschst, werden alle anderen Kopien ebenfalls entfernt.",
    "deleteSharedConfirmationMessage": "Bist du sicher, dass du die geteilte Karte aus diesem Projekt entfernen möchtest?",
    "confirm": "Bestätigen",
    "globalSearch": "Karten durchsuchen",
    "cardErrors": "Fehler in Karten",
    "cardErrorsTitle": "Fehler in aktuellen Karten",
    "cardErrorsFilterAll": "Alle",
    "cardErrorsFilterButton": "Fehlerarten",
    "cardErrorsFilterMenuTitle": "Fehlerarten auswählen",
    "cardErrorsSelected": "{count} ausgewählt",
    "cardErrorsCount": "{shown} von {total} Karten",
    "cardErrorsResetFilters": "Zurücksetzen",
    "cardErrorsApplyFilters": "Filter anwenden",
    "cardErrorsNoErrors": "Keine Fehler in aktuellen Karten.",
    "cardErrorsNoMatchingCards": "Keine Karten entsprechen den ausgewählten Fehlerfiltern.",
    "projectsWithoutShepherd": "Projekte ohne Project Shepherd",
    "projectsWithoutShepherdHint": "Keiner der Shepherds dieser Projekte arbeitet mehr bei TNG. Bitte einen neuen Project Shepherd eintragen.",
    "cardErrorsColumn": "Fehler",
    "cardErrorMissingSenderManual": "Versender fehlt (manueller Versand)",
    "cardErrorMissingSenderManualHint": "Es wurde kein Versender ausgewählt.",
    "cardErrorMissingSenderAutomatic": "Versender fehlt (automatischer Versand)",
    "cardErrorMissingSenderAutomaticHint": "Es wurde kein Versender ausgewählt.",
    "cardErrorEmailSenderManual": "E-Mail-Versender (manueller Versand)",
    "cardErrorEmailSenderManualHint": "Für den manuellen Versand muss eine Person als Versender eingetragen sein.",
    "cardErrorXmasSenderAutomatic": "xmas@-Versender (automatischer Versand)",
    "cardErrorXmasSenderAutomaticHint": "Statt xmas@ werden Personen oder Abteilungen als Versender bevorzugt.",
    "cardErrorSenderUnknown": "Versender unbekannt",
    "cardErrorSenderUnknownHint": "Der Versender ist nicht oder nicht mehr bei TNG. Bitte einen neuen Versender wählen.",
    "cardErrorSenderNotSigner": "Versender hat nicht unterschrieben",
    "cardErrorSenderNotSignerHint": "Der Versender hat diese Karte nicht unterschrieben.",
    "cardErrorDuplicateEmail": "Doppelte E-Mail-Adresse",
    "cardErrorDuplicateEmailHint": "Eine weitere Karte nutzt dieselbe E-Mail-Adresse.",
    "cardErrorDuplicateName": "Doppelter Name",
    "cardErrorDuplicateNameHint": "Eine weitere Karte nutzt denselben Namen.",
    "cardErrorContactDetailsInconsistent": "Inkonsistente Kontaktdaten",
    "cardErrorContactDetailsInconsistentHint": "Name, Anrede und E-Mail-Adresse passen möglicherweise nicht zusammen.",
    "cardStatusWarning": "Warnung",
    "cardStatusError": "Fehler",
    "manualDispatchPageTitle": "Manueller Versand",
    "manualDispatchNotYetAvailable": "Verfügbar sobald der automatische Versand abgeschlossen ist.",
    "comingSoon": "Bald verfügbar",
    "pageNotAvailable": "In Vorbereitung...",
    "manualDispatchNotActiveWarning": "Noch gibt es nichts zu tun: Die automatischen E-Mails wurden noch nicht versendet. Deine Karten zum Versenden erscheinen hier, sobald das passiert ist.",
    "manualDispatchActiveInfo": "Die automatischen E-Mails wurden versendet. Deine Karten zum Versenden findest du unten.",
    "manualDispatchEmptyList": "Du hast keine Karten, die du manuell versenden musst.",
    "manualDispatchStatusSent": "Versendet",
    "manualDispatchStatusOpen": "Offen",
    "manualDispatchSendMail": "E-Mail senden",
    "manualDispatchMarkSent": "Als versendet markieren",
    "manualDispatchMarkUnsent": "Als nicht versendet markieren",
    "refresh": "Aktualisieren",
    "searchAllCards": "Karten nach Namen oder E-Mail durchsuchen",
    "projectDisplayName": "Projekt",
    "language": "Sprache",
    "statusColumn": "Status",
    "mySignedCards": "Meine unterschriebenen Karten",
    "myChristmasCardPortrait": "Mein Weihnachtskarten-Porträt",
    "opensInNewTab": "öffnet sich in einem neuen Tab",
    "mySignedCardsEmptyList": "Du hast noch keine Karten unterschrieben.",
    "mySignedCardsNoMatchingCards": "Keine deiner unterschriebenen Karten passt zur Suche.",
    "home": "Startseite",
    "close": "Schließen",
    "closeForm": "Formular schließen",
    "showDetails": "Details anzeigen",
    "removeSharedCard": "Geteilte Karte entfernen",
    "openResponsibleProject": "Verantwortliches Projekt öffnen",
    "errorUnexpected": "Ups, da ist etwas schiefgelaufen!",
    "errorLoadingLoginConfig": "Fehler beim Laden der Login-Konfiguration",
    "guide": "Anleitung",
    "guideBackLink": "Zurück zur Startseite",
    "countdownDays": "Tage",
    "countdownHours": "Stunden",
    "countdownMinutes": "Minuten",
    "countdownAriaLabel": "Countdown bis zum {deadline}"
  },
  "EN": {
    "appTitle": "TNG Christmas Card Address Collection",
    "appTitleTest": "--- TEST --- TNG Christmas Card Address Collection",
    "pleaseLogIn": "Please log in first",
    "unknownErrorTryAgainLater": "An error occurred. Please try again later.",
    "projectCardListTitle": "Christmas Card Signature List",
    "projectCardListShepherds": "Shepherds",
    "projectCardListEmptyList": "There are no cards in this project yet.",
    "projectCardListNoMatchingCards": "No card in this project matches the search.",
    "globalSearchListTitle": "Global Card Search",
    "exportCards": "Export Cards",
    "errorExportCards": "Error exporting the cards",
    "exportEmails": "Export Emails",
    "errorExportEmails": "Error exporting the emails",
    "globalSearchMoreCardsWarning": "More than 100 cards found. Please refine your search.",
    "globalSearchNoResults": "No cards found.",
    "cardTableHeaderName": "Name",
    "cardTableHeaderSigned": "Signed",
    "cardTableHeaderDepartmentName": "Department",
    "cardTableHeaderEmail": "Email",
    "cardTableHeaderProject": "Project",
    "cardTableHeaderDispatch": "Dispatch",
    "cardTableHeaderSender": "Sender",
    "cardTableHeaderCompanyName": "Company",
    "cardTableHeaderReceivesGift": "Gift",
    "cardTableHeaderLanguage": "Language",
    "cardTableHeaderComment": "Comment",
    "cardTableHeaderCreatedAt": "Created (UTC)",
    "cardTableHeaderLastChangedAt": "Last change (UTC)",
    "cardTableHeaderSalutation": "Salutation",
    "cardTableHeaderFormality": "Formality",
    "cardTableHeaderTitle": "Title",
    "cardTableCellDispatchAutomatic": "auto",
    "cardTableCellDispatchManual": "manual",
    "cardTableCellYes": "yes",
    "cardTableCellNo": "no",
    "searchCardsPlaceholder": "Search cards...",
    "noPermissionToViewProject": "You don't have access to this list.",
    "noPermissionToViewProjectContact": "You don't have access to this list. To gain access to this list, please contact one of the Shepherds (see above).",
    "signCard": "Sign card",
    "signatureOnlyRemovable": "You no longer have access to this project. You can only remove your signature.",
    "errorCardDelete": "Error deleting the card",
    "errorRemovingSharedCard": "Error removing the shared card",
    "licenses": "Licenses",
    "formal": "formal",
    "informal": "informal",
    "semiFormal": "semi-formal",
    "departmentName": "Department",
    "firstName": "First name",
    "lastName": "Last name",
    "email": "Email",
    "formalityLabel": "Formality",
    "receivesGift": "Receives gift",
    "automaticDispatch": "Automatic dispatch by IIT",
    "languageLabel": "Language of the card",
    "english": "English",
    "german": "German",
    "male": "male",
    "female": "female",
    "cancel": "Cancel",
    "saveChanges": "Save Changes",
    "saveAndNew": "Save & New",
    "shareCard": "Share",
    "changesSaved": "Changes saved.",
    "errorSavingChanges": "Error saving the changes",
    "editCardTitle": "Edit Card",
    "classificationReasonTypoEmailOrName": "The email address and name may not match or may contain a typo.",
    "classificationReasonMismatchSalutation": "The salutation may not match the first name.",
    "markContactDetailsCorrect": "Mark as Correct",
    "markContactDetailsCorrectDialogTitle": "Mark Contact Details as Correct",
    "markContactDetailsCorrectDialogMessage": "Accurate data is important to ensure a professional image of TNG.\nAre you sure you want to mark these contact details as correct?",
    "contactDetailsMarkedCorrect": "The contact details were marked as correct.",
    "errorMarkingContactDetailsCorrect": "Error marking the contact details as correct",
    "editCardSignatures": "Edit Signatures",
    "addCardSignatures": "Add Signatures",
    "removeCardSignatures": "Remove Signatures",
    "cardSignaturesToAdd": "Signatures to add",
    "cardSignaturesToRemove": "Signatures to remove",
    "firstNameRequired": "First name is required.",
    "lastNameRequired": "Last name is required.",
    "emailRequiredForAutomaticDispatch": "Email is required when automatic dispatch is enabled.",
    "senderRequiredForManualDispatch": "Sender is required when automatic dispatch is disabled.",
    "emailSenderNotPossibleForManualDispatch": "Manual dispatch is not possible with an email sender.",
    "selectAtLeastOneShepherd": "Designate at least one Shepherd.",
    "noSemiFormalAvailable": "A semi-formal salutation is not available for the selected language.",
    "inputRequired": "Input is required.",
    "salutation": "Salutation",
    "title": "Title",
    "none": "None",
    "sender": "Sender",
    "comment": "Comment",
    "companyName": "Company",
    "salutationHelperText": "Should you wish to use a neutral/diverse salutation, please send an email to communications@tngtech.com.",
    "formalityHelperTextDE": "- formal → \"Sehr geehrte Frau $Nachname / Sehr geehrter Herr $Nachname\"\n- semi-formal → \"Liebe Frau $Nachname / Lieber Herr $Nachname\"\n- informal → \"Liebe/r $Vorname\"",
    "formalityHelperTextEN": "- formal → \"Dear Mr $Last Name / Dear Ms $Last Name\"\n- informal → \"Dear $First Name\"",
    "emailHelperText": "If no recipient email is given, you'll have to send the card manually.",
    "commentHelperText": "You can make any comments here that help you. However, we will not check or look at them.",
    "receivesGiftHelperText": "The recipient gets a chocolate voucher. Please do not select it when they live outside of Germany (high shipping costs).",
    "automaticDispatchHelperText": "When disabled, the card is made available to the sender for manual dispatch. Please make sure the card reaches the recipient!",
    "senderHelperText": "The card will be sent from this mailbox. You can select individuals and predefined mailboxes from the dropdown menu, but no mailing lists.",
    "createCardTitle": "Create Card",
    "errorCardEmailNotUnique": "A card with this email address already exists.",
    "shareCardWarning": "This card already exists in another project",
    "shareCardOption": "If you would like to link it to this project too, you can share it here.",
    "errorCardNameNotUnique": "A card with this name already exists.",
    "createCardButton": "Create Card",
    "manageProjectButton": "Manage Project",
    "manageProjectPermissions": "Manage Project Permissions",
    "errorProjectNameNotUnique": "A project with this name already exists.",
    "displayNameRequired": "Display name is required.",
    "displayName": "Display name",
    "infoBox": "Additional information",
    "infoBoxHelperText": "Any additional information for the project",
    "projectShepherds": "Project Shepherds",
    "projectMembers": "Project Members",
    "projectSigners": "Project Signers",
    "projectShepherdIndividuals": "Shepherd individuals",
    "projectMemberIndividuals": "Member individuals",
    "projectSignerIndividuals": "Signer individuals",
    "projectShepherdGroups": "Shepherd groups",
    "projectMemberGroups": "Member groups",
    "projectSignerGroups": "Signer groups",
    "displayNameHelperText": "Please use a unique name for your project.",
    "projectShepherdsHelperText": "Can manage project settings and permissions.",
    "projectMembersHelperText": "Can create, edit, and delete cards.",
    "projectSignersHelperText": "Can sign cards, but cannot see or change confidential contact details.",
    "groupSelectionHelperText": "The dropdown options only mirror your own LDAP groups. You can add any other LDAP group by typing or copying it into the field.",
    "projects": "Projects",
    "loading": "...loading...",
    "noOptions": "<empty>",
    "delete": "Delete",
    "cardDeleted": "Card deleted.",
    "sharedCardRemoved": "Shared card removed.",
    "createProject": "Create Project",
    "deleteConfirmationTitle": "Delete Card",
    "deleteConfirmationMessage": "Are you sure you want to delete the card?\nRecipient: {recipient}",
    "deleteConfirmationMessageWithSharedCards": "This card is currently shared in other projects. Deleting it here will delete all other copies as well.",
    "deleteSharedConfirmationMessage": "Are you sure you want to remove this shared card?",
    "confirm": "Confirm",
    "globalSearch": "Search Cards",
    "cardErrors": "Card Errors",
    "cardErrorsTitle": "Errors in Current Cards",
    "cardErrorsFilterAll": "All",
    "cardErrorsFilterButton": "Error Types",
    "cardErrorsFilterMenuTitle": "Select Error Types",
    "cardErrorsSelected": "{count} selected",
    "cardErrorsCount": "{shown} of {total} cards",
    "cardErrorsResetFilters": "Reset",
    "cardErrorsApplyFilters": "Apply Filters",
    "cardErrorsNoErrors": "No errors in current cards.",
    "cardErrorsNoMatchingCards": "No cards match the selected error filters.",
    "projectsWithoutShepherd": "Projects Without a Project Shepherd",
    "projectsWithoutShepherdHint": "None of the Shepherds of these projects works at TNG anymore. Please assign a new Project Shepherd.",
    "cardErrorsColumn": "Errors",
    "cardErrorMissingSenderManual": "Sender missing (manual dispatch)",
    "cardErrorMissingSenderManualHint": "The card is missing a sender.",
    "cardErrorMissingSenderAutomatic": "Sender missing (automatic dispatch)",
    "cardErrorMissingSenderAutomaticHint": "The card is missing a sender.",
    "cardErrorEmailSenderManual": "Email sender (manual dispatch)",
    "cardErrorEmailSenderManualHint": "Manual dispatch requires a person as the sender.",
    "cardErrorXmasSenderAutomatic": "xmas@ sender (automatic dispatch)",
    "cardErrorXmasSenderAutomaticHint": "Prefer people/departments as senders over xmas@.",
    "cardErrorSenderUnknown": "Sender unknown",
    "cardErrorSenderUnknownHint": "The sender is not a current TNG employee. Please choose a new sender.",
    "cardErrorSenderNotSigner": "Sender didn't sign",
    "cardErrorSenderNotSignerHint": "The card is not signed by its sender.",
    "cardErrorDuplicateEmail": "Duplicate email address",
    "cardErrorDuplicateEmailHint": "Another card uses the same email address.",
    "cardErrorDuplicateName": "Duplicate name",
    "cardErrorDuplicateNameHint": "Another card has the same name.",
    "cardErrorContactDetailsInconsistent": "Inconsistent contact details",
    "cardErrorContactDetailsInconsistentHint": "Name, salutation, and email may not fit together.",
    "cardStatusWarning": "Warning",
    "cardStatusError": "Error",
    "manualDispatchPageTitle": "Manual Dispatch",
    "manualDispatchNotYetAvailable": "Available once the automatic emails have been sent out.",
    "comingSoon": "Coming soon",
    "pageNotAvailable": "Under construction...",
    "manualDispatchNotActiveWarning": "Nothing to do yet: the automatic emails have not been sent out. Your cards to send will appear here once they have.",
    "manualDispatchActiveInfo": "The automatic emails have been sent out. Your cards to send are listed below.",
    "manualDispatchEmptyList": "You don't have any cards to send manually.",
    "manualDispatchStatusSent": "Sent",
    "manualDispatchStatusOpen": "Open",
    "manualDispatchSendMail": "Send Email",
    "manualDispatchMarkSent": "Mark as Sent",
    "manualDispatchMarkUnsent": "Mark as Not Sent",
    "refresh": "Refresh",
    "searchAllCards": "Search cards by name or email",
    "projectDisplayName": "Project",
    "language": "Language",
    "statusColumn": "Status",
    "mySignedCards": "My Signed Cards",
    "myChristmasCardPortrait": "My Card Portrait",
    "opensInNewTab": "opens in a new tab",
    "mySignedCardsEmptyList": "You haven't signed any cards yet.",
    "mySignedCardsNoMatchingCards": "None of your signed cards matches the search.",
    "home": "Home",
    "close": "Close",
    "closeForm": "Close form",
    "showDetails": "Show details",
    "removeSharedCard": "Remove shared card",
    "openResponsibleProject": "Open responsible project",
    "errorUnexpected": "Oops, something went wrong!",
    "errorLoadingLoginConfig": "Error loading the login configuration",
    "guide": "Guide",
    "guideBackLink": "Back to home",
    "countdownDays": "Days",
    "countdownHours": "Hours",
    "countdownMinutes": "Minutes",
    "countdownAriaLabel": "Countdown until {deadline}"
  }
}
